<div class="row sub-title" (click)="open ? open = false : open = true">
    <div class="col-12">
        <img src="/assets/images/icons/add.svg" *ngIf="!open" />
        <img src="/assets/images/icons/minus.svg" *ngIf="open" />
        <span class="font-mont-semi-bold">RISK</span>
    </div>
</div>
<div class="row container" [ngClass]="{ 'open': open }">
    <div class="col-12 summary hide-mobile">
        <table class="summary">
            <tbody>
                <tr>
                    <td>Data Robot Model:</td>
                    <td>{{risk.dataRobotModel}}</td>
                    <td>Decline Rule:</td>
                    <td>{{risk.declineRule}}</td>
                </tr>
                <tr>
                    <td>VOD Rule:</td>
                    <td>{{risk.vodRule}}</td>
                    <td>Decline Date:</td>
                    <td>{{risk.declineDate | date:'MM/yyyy'}}</td>
                </tr>
                <tr>
                    <td>PreCredit Rule:</td>
                    <td>{{risk.preCreditRule}}</td>
                    <td>Term Rule:</td>
                    <td>{{risk.termRule}}</td>
                </tr>
                <tr>
                    <td>Minimum Offer Term:</td>
                    <td>{{risk.termMin}}</td>
                    <td>Max Offer Term:</td>
                    <td>{{risk.termMax}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-12 summary only-mobile">
        <table class="summary">
            <tbody>
                <tr>
                    <td>Data Robot Model:</td>
                    <td>{{risk.dataRobotModel}}</td>
                </tr>
                <tr>
                    <td>Decline Rule:</td>
                    <td>{{risk.declineRule}}</td>
                </tr>
                <tr>
                    <td>VOD Rule:</td>
                    <td>{{risk.vodRule}}</td>
                </tr>
                <tr>
                    <td>Decline Date:</td>
                    <td>{{risk.declineDate | date:'MM/yyyy'}}</td>
                </tr>
                <tr>
                    <td>PreCredit Rule:</td>
                    <td>{{risk.preCreditRule}}</td>
                </tr>
                <tr>
                    <td>Term Rule:</td>
                    <td>{{risk.termRule}}</td>
                </tr>
                <tr>
                    <td>Minimum Offer Term:</td>
                    <td>{{risk.termMin}}</td>
                </tr>
                <tr>
                    <td>Max Offer Term:</td>
                    <td>{{risk.termMax}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-12" *ngIf="risk.pricingAdjustments">
        <table>
            <thead>
                <tr>
                    <th class="font-mont-semi-bold text-center" colspan="2">Pricing Adjustments</th>
                </tr>
                <tr>
                    <th class="font-mont-semi-bold text-center">Name</th>
                    <th class="font-mont-semi-bold text-center">Value</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let pricingAdjustment of risk.pricingAdjustments">
                    <td class="text-center">{{pricingAdjustment.adjustmentName}}</td>
                    <td class="text-center">{{pricingAdjustment.adjustmentValue}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="col-12" *ngIf="risk.maxFundingAdjustments">
        <table>
            <thead>
                <tr>
                    <th class="font-mont-semi-bold text-center" colspan="2">Max Funding Adjustments</th>
                </tr>
                <tr>
                    <th class="font-mont-semi-bold text-center">Name</th>
                    <th class="font-mont-semi-bold text-center">Value</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let maxFundingAdjustment of risk.maxFundingAdjustments">
                    <td class="text-center">{{maxFundingAdjustment.adjustmentName}}</td>
                    <td class="text-center">{{maxFundingAdjustment.adjustmentValue}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>